import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import { FiMinus } from 'react-icons/fi';
import { updateInvoiceDetails } from './actions';
import { toastError, toastSuccess } from '../../../utils';
const initialAmountEntries = [
    { amount: '', date: '' }
];

const AccountingViewModel = ({ data, refetch, closeModel }) => {
    const [formData, setFormData] = useState({
        ...data,
        amountSettled: data.amountSettled || initialAmountEntries,
    });

    const editableFields = [
        'payOrderNo',
        'txnRefCode',
        'closureDate',
        'status',
        'viaCompany',
        'viaCompanyCode'
    ];

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toISOString().slice(0, 16);
    };

    const handleSaveChanges = async () => {
        try {
            const editableData = Object.fromEntries(
                Object.entries(formData).filter(([key]) => [...editableFields, 'amountSettled', 'amountSettledTotal'].includes(key))
            );
            await updateInvoiceDetails(
                { id: formData.requestId },
                editableData
            );
            toastSuccess("Invoice updated successfully");
            refetch();
            closeModel();
        } catch (error) {
            console.log(error);
            toastError("Failed to update invoice");
        }
    }

    const renderInput = (field, label, type = "text") => {
        const isEditable = editableFields.includes(field);
        const value = type === "datetime-local" ? formatDateForInput(formData[field]) : formData[field];

        if (field === 'status') {
            return (
                <div className="mb-2">
                    <label className="block text-[11px] font-medium text-slate-700 mb-0.5">
                        {label}
                    </label>
                    <select
                        value={value}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        disabled={!isEditable}
                        className={`w-full h-7 px-2 py-1 border rounded-none text-[11px] font-medium transition-colors ${isEditable
                            ? 'border-slate-300 bg-white text-slate-800 focus:outline-none focus:border-[#313C4C]'
                            : 'border-slate-200 bg-slate-100 text-slate-600 cursor-not-allowed'
                            }`}
                    >
                        <option value="Posted">Posted</option>
                        <option value="Partially Complete">Partially Complete</option>
                        <option value="Completed">Completed</option>
                    </select>
                </div>
            );
        }

        if (field === 'amountSettledTotal') {
            return (
                <div className="mb-2">
                    <label className="block text-[11px] font-medium text-slate-700 mb-0.5">
                        {label}
                    </label>
                    <div className="flex items-center space-x-2">
                        <input
                            type="number"
                            value={value}
                            disabled={!isEditable}
                            className={`flex-1 h-7 px-2 py-1 border rounded-none text-[11px] font-medium transition-colors ${isEditable
                                ? 'border-slate-300 bg-white text-slate-800 focus:outline-none focus:border-[#313C4C]'
                                : 'border-slate-200 bg-slate-100 text-slate-600 cursor-not-allowed'
                                }`}
                            readOnly
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="mb-2">
                <label className="block text-[11px] font-medium text-slate-700 mb-0.5">
                    {label}
                </label>
                <input
                    type={type}
                    value={value}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                    disabled={!isEditable}
                    className={`w-full h-7 px-2 py-1 border rounded-none text-[11px] font-medium transition-colors ${isEditable
                        ? 'border-slate-300 bg-white text-slate-800 focus:outline-none focus:border-[#313C4C]'
                        : 'border-slate-200 bg-slate-100 text-slate-600 cursor-not-allowed'
                        }`}
                    placeholder={isEditable ? `Enter ${label.toLowerCase()}` : ''}
                />
            </div>
        );
    };

    return (
        <div className="max-w-6xl mx-auto p-3 text-[11px] font-medium bg-white">

            <div className="grid grid-cols-3 gap-3">
                <div>
                    {renderInput('requestId', 'Request ID')}
                    {renderInput('requestDate', 'Request Date', 'datetime-local')}
                    {renderInput('requestType', 'Request Type')}
                    {renderInput('invoiceNo', 'Invoice Number')}
                    {renderInput('viaCompany', 'Via Company')}
                    {renderInput('viaCompanyCode', 'Via Company Code')}
                    {renderInput('status', 'Status')}

                </div>

                <div>
                    {renderInput('opsPIC', 'Operations PIC')}
                    {renderInput('opsId', 'Operations ID')}
                    {renderInput('cargoName', 'Cargo Name')}
                    {renderInput('shipmentNumber', 'Shipment Number')}
                    {renderInput('vesselName', 'Vessel Name')}
                    {renderInput('voyageNumber', 'Voyage Number')}
                    {renderInput('vesselCode', 'Vessel Code')}
                </div>

                <div>
                    {renderInput('currency', 'Currency')}
                    {renderInput('amount', 'Amount', 'number')}
                    {renderInput('amountSettledTotal', 'Amount Settled', 'number')}
                    {renderInput('payOrderNo', 'Pay Order Number')}
                    {renderInput('txnRefCode', 'Transaction Reference')}
                    {renderInput('accountingDate', 'Accounting Date', 'datetime-local')}
                    {renderInput('closureDate', 'Closure Date', 'datetime-local')}
                </div>
            </div>

            <div className="mt-3 flex justify-end items-center">
                <button
                    onClick={handleSaveChanges}
                    className="h-7 px-3 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#1e2632] transition shadow-2xs cursor-pointer rounded-none"
                >
                    Save Changes
                </button>
            </div>
        </div>
    );
};

export default AccountingViewModel;